import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRoles } from 'utils/auth';

export const RoleGuardedRoute: React.FC<{ role: string; element: React.ReactElement }> = ({ role, element }) => {
  const roles = useRoles();
  return roles?.includes(role) ? element : <Navigate to="/" replace />;
};
